module.exports = __webpack_public_path__ + "img/Vangsgutane_Bilde-av-Lise-Myhre.ebad12c2.jpg";